import { InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { InvoiceView } from '../InvoiceView'

@InputType()
export class GetInvoiceByDocumentLinkArgs extends ActionArgs {
  // arrives inside untyped JSON `filter`; the document link service type-checks it
  token?: unknown
}

export interface IGetInvoiceByDocumentLink extends IAction<InvoiceView, GetInvoiceByDocumentLinkArgs> {}
